import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Flex, xcss } from '@atlaskit/primitives';

const bylineStyles = xcss({
	height: '32px', // this value MUST match the fixed height of the LivePagesBylineStyledMainDiv in PresentationalComponents.tsx
});

const circleStyles = xcss({
	backgroundColor: 'color.skeleton',
	width: '20px',
	height: '20px',
	borderRadius: 'radius.full',
	margin: 'space.025',
});

const lineStyles = xcss({
	backgroundColor: 'color.skeleton',
	width: '100px',
	height: '16px',
	borderRadius: 'radius.xsmall',
});

export const LivePagesByLinePlaceholderComponent = () => {
	return (
		<Flex
			alignItems="center"
			gap="space.050"
			xcss={bylineStyles}
			testId="live-pages-by-line-placeholder"
		>
			<Box xcss={circleStyles} />
			<Box xcss={lineStyles} />
		</Flex>
	);
};
